import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Avatar } from '../../components/Avatar'
import { Button } from '../../components/Button'
import { Card } from '../../components/Card'
import { Col } from '../../components/Col'
import { Container } from '../../components/Container'
import { Row } from '../../components/Row'
import ArrowUpRight from '../../components/svg/ArrowUpRight'
import Copy from '../../components/svg/Copy'
import Telegram from '../../components/svg/Telegram'
import Twitter from '../../components/svg/Twitter'
import styles from './styles.module.css'
import Lock from '../../components/svg/Lock'
import Stack2 from '../../components/svg/Stack2'
import PersonsBig from '../../components/svg/PersonsBig'
import PersonPlus from '../../components/svg/PersonPlus'
import {
  followProfile,
  getProfileFollowers,
  getProfileFollowings,
  getProfileInfo
} from '../../services/profileService'
import { useWallet } from '@solana/wallet-adapter-react'
import { useModalContext } from '../../providers/modal'
import { EditProfile } from '../../containers/EditProfile'
import { useAuthContext } from '../../providers/auth'
import { Followers } from '../../containers/Followers'
import { Followings } from '../../containers/Followings'

export const User = () => {
  const tabs = [
    { name: 'coin held', icon: <Lock style={{ color: '#00FF94' }} /> },
    { name: 'coin created', icon: <Stack2 style={{ color: '#00FF94' }} /> },
    { name: 'followers', icon: <PersonsBig style={{ color: '#00FF94' }} /> },
    { name: 'following', icon: <PersonPlus style={{ color: '#00FF94' }} /> }
  ]
  const { setContent, setIsModalOpen } = useModalContext()
  const { address = '' } = useParams<{ address: string }>()
  const [activeTab, setActiveTab] = useState(0)
  const [followers, setFollowers] = useState<number>(0)
  const wallet = useWallet()
  const { accessToken } = useAuthContext()
  const [profile, setProfile] = useState<any>(null)
  const [copyId, setCopyId] = useState<string | null>(null)
  const copy = useCallback(
    (value: string, id: string) => {
      navigator.clipboard.writeText(value)
      setCopyId(id)
      setTimeout(() => {
        setCopyId(null)
      }, 1000)
    },
    [setCopyId]
  )

  useEffect(() => {
    if (address) {
      getProfileInfo(address).then((data) => {
        console.log(data)
        setProfile(data)
      })
      getProfileFollowers(address).then((data) => {
        setFollowers(data.totalCount)
      })
      getProfileFollowings(address).then((data) => {
        console.log(data)
      })
    }
  }, [address])

  const editProfile = useCallback(() => {
    setContent(
      <EditProfile
        onClose={() => {
          setIsModalOpen(false)
          setContent(null)
        }}
        defaultValues={{
          nickname: profile?.nickname,
          twitter: profile?.twitter,
          telegram: profile?.telegram
        }}
        onProfileUpdated={setProfile}
      />
    )
    setIsModalOpen(true)
  }, [profile, setContent, setIsModalOpen])

  const toggleFollow = useCallback(() => {
    if (!accessToken) return
    followProfile(address, accessToken).then((data) => {
      console.log(data)
    })
  }, [address, accessToken])

  return (
    <div className={styles.container}>
      <Container>
        <Row>
          <Col size={8} className={styles.col}>
            <Card className={styles.card}>
              <div className={styles.userBlock}>
                <div className={styles.userInfo}>
                  <div className={styles.avatarBlock}>
                    <Avatar
                      size={111}
                      src={profile?.image_url || '/doge.png'}
                    />
                  </div>
                  <div className={styles.userDetails}>
                    <div className={styles.userNameRow}>
                      <div className={styles.userName}>
                        {profile?.nickname || ''}
                      </div>
                      <div className={styles.userLinks}>
                        {profile?.twitter && (
                          <a
                            href={profile.twitter}
                            className={styles.userLink}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Twitter />
                          </a>
                        )}
                        {profile?.telegram && (
                          <a
                            href={profile.telegram}
                            className={styles.userLink}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Telegram />
                          </a>
                        )}
                      </div>
                    </div>
                    <div className={styles.userFollowers}>
                      Followers:{' '}
                      <span className={styles.green}>{followers}</span>
                    </div>
                    <div
                      className={styles.userAddress}
                      style={
                        copyId === 'copy'
                          ? {
                              color: '#00ff94'
                            }
                          : {}
                      }
                      onClick={() => {
                        copy(address, 'copy')
                      }}
                    >
                      <Copy style={{ minWidth: 17 }} />
                      <span>&nbsp; {address}</span>
                    </div>
                    <a
                      className={styles.userSolscan}
                      href={'https://solscan.io/account/' + address}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <ArrowUpRight />
                      <span>&nbsp; View on solscan</span>
                    </a>
                  </div>
                </div>
                <div className={styles.userActions}>
                  {!wallet.publicKey?.toBase58() ? null : address ===
                    wallet.publicKey?.toBase58() ? (
                    <Button className={styles.editButton} onClick={editProfile}>
                      Edit profile
                    </Button>
                  ) : (
                    <Button
                      className={styles.followButton}
                      onClick={toggleFollow}
                    >
                      Follow
                    </Button>
                  )}
                </div>
              </div>
              <div className={styles.tabs}>
                {tabs.map((tab, index) => (
                  <div
                    key={tab.name}
                    className={`${styles.tab} ${
                      index === activeTab ? styles.activeTab : ''
                    }`}
                    onClick={() => setActiveTab(index)}
                  >
                    {tab.icon}
                    {tab.name}
                  </div>
                ))}
              </div>
              {activeTab === 0 && <div>coin held</div>}
              {activeTab === 1 && <div>coin created</div>}
              {activeTab === 2 && <Followers address={address} />}
              {activeTab === 3 && <Followings address={address} />}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
